// extracted by mini-css-extract-plugin
module.exports = {"main":"nav_main__U382r"};